module.exports = __webpack_public_path__ + "staticcomp/img/content_1.b79aab6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/3/content_1.jpg
// module id = ldoH
// module chunks = 39